<div class="grid p-fluid">
    <div class="col-12" *ngIf="isLoading()">
        <div class="flex align-items-center justify-content-center w-full">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
        </div>
    </div>
    <div class="col-12" *ngIf="!isLoading()">
        <div *ngIf="timerCheck && !clockPresent" class="flex align-items-center justify-content-center bg-yellow-200 border-round-xl p-1 mb-2">
            <p-tag icon="pi cm-alert" [value]="('CLOCK_BOARD_NOT_AVAILABLE' | translate)" severity="warning"></p-tag>
        </div>
        <p-tabView [scrollable]="true" [activeIndex]="activeIndex" (onChange)="selectedIndexChange($event)"
            styleClass="transparent-tabView">
            <!-- INFO -->
            <p-tabPanel header="{{ 'INFO' | translate }}">
                <div *ngIf="navItems.length > 0" fxLayout="row" class="mb-3" fxLayoutAlign="">
                    <div class="flex flex-row align-items-center surface-400 border-round-xl"
                        style="border: 1px solid #D5D5D5">
                        <label class="font-semibold ml-3">{{ 'CONNECTED_TO' | translate }} : </label>
                        <app-breadcrumb [items]="navItems"></app-breadcrumb>
                        <p-breadcrumb styleClass="border-none" [model]="navItems" [home]="home"></p-breadcrumb>
                    </div>
                </div>
                <app-device-info *ngIf="!isVirtualDevice()"></app-device-info>
                <app-virtual-device *ngIf="isVirtualDevice()"></app-virtual-device>
                <app-outputs *ngIf="isRbe4() || isRbe24230()"></app-outputs>
                <app-inputs *ngIf="isRbe24230()"></app-inputs>
                <app-commands *ngIf="!isVirtualDevice() && checkFeature('commands')"></app-commands>
                <app-io-commands *ngIf="isVirtualDevice()"></app-io-commands>
                <app-thermo-commands *ngIf="isThermoDevice()"></app-thermo-commands>
                <app-support-automation *ngIf="isRbe24230()"></app-support-automation>
            </p-tabPanel>
            <!-- MTMA -->
            <p-tabPanel *ngIf="hasManageModule()" header="{{ 'MANAGE_MODULE' | translate }}">
                <app-mtma-manage-module></app-mtma-manage-module>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasManageContact()" header="{{ 'MANAGE_CONTACT' | translate }}"
                tooltip="{{ 'MANAGE_CONTACT_INFO' | translate }}">
                <app-mtma-manage-contact></app-mtma-manage-contact>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasManageUnit()" header="{{ 'MANAGE_UNIT' | translate }}"
                tooltip="{{ 'MANAGE_UNIT_INFO_NEW' | translate }}">
                <app-mtma-manage-unit></app-mtma-manage-unit>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasManageDtmfTone()" header="{{ 'MANAGE_DTMF_TONES' | translate }}">
                <app-mtma-manage-dtmf-tone></app-mtma-manage-dtmf-tone>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasManageTag()" header="{{ 'MANAGE_TAGS' | translate }}"
                [disabled]="!isManageTagEnabled()">
                <app-mtma-manage-tag></app-mtma-manage-tag>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasManageKeypad()" header="{{ 'MANAGE_KEYPADS' | translate }}"
                [disabled]="!isManageKeypadEnabled()">
                <app-mtma-manage-keypad></app-mtma-manage-keypad>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasManageMtmaPermission()" header="{{ 'QUICK_EASY' | translate }}">
                <app-mtma-manage-permissions></app-mtma-manage-permissions>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasManageRulesAccess()" header="{{ 'MANAGE_RULES_ACCESS' | translate }}"
                tooltip="{{ 'MANAGE_RULES_ACCESS_INFO' | translate }}">
                <app-mtma-rules-access></app-mtma-rules-access>
            </p-tabPanel>
            <!-- <p-tabPanel *ngIf="hasManageRulesAccess()" header="{{ 'MANAGE_CONTROL_ACCESS' | translate }}">
                <app-mtma-control-access-tab></app-mtma-control-access-tab>
            </p-tabPanel> -->
            <p-tabPanel *ngIf="hasMtmaLogCalls()" header="{{ 'ACCESS_LOG' | translate }}">
                <app-access-log></app-access-log>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasMtmaLogCalls()" header="{{ 'LOG_CALLS' | translate }}">
                <app-call-access-log></app-call-access-log>
            </p-tabPanel>
            <!-- SETTINGS -->
            <p-tabPanel *ngIf="hasSettingsTab() && isOwnerAndMtma()" header="{{ 'SETTINGS' | translate }}">
                <p-accordion>
                    <app-remote-devices *ngIf="hasRemoteDevices()"></app-remote-devices>
                    <app-final-users *ngIf="hasFinalUsers()"></app-final-users>
                    <app-settings *ngIf="checkFeature('settings') && device.CurrentlyOwned"></app-settings>
                    <app-device-profiles *ngIf="hasProfiles()"></app-device-profiles>
                    <app-final-users-profiles *ngIf="hasProfiles() && device.CurrentlyOwned"></app-final-users-profiles>
                    <app-import-final-users *ngIf="hasImportFinalUsers()"></app-import-final-users>
                    <app-notifications-legacy-mtma *ngIf="hasNotificationsMtmaConnectOldFwVer()"></app-notifications-legacy-mtma>
                    <app-notifications-device-tab *ngIf="hasNotifications()" [device]="device"
                        [userCurrentlyOwner]="device.CurrentlyOwned && isUser"></app-notifications-device-tab>
                    <app-safety-inputs *ngIf="hasSafetyInputs()"></app-safety-inputs>
                    <!-- Button edit password-->
                    <div class="grid" style="padding-top: 20px;"
                        *ngIf="(passwordSupport && currentDeviceStatus.Online && (isTechnician || isImpersMode)) || isMTMAConnect()">
                        <div [class]="col6ResponsiveButtonLayout('left')"></div>
                        <div [class]="col6ResponsiveButtonLayout('right')">
                            <p-button
                                *ngIf="passwordSupport && currentDeviceStatus.Online && (isTechnician || isImpersMode)"
                                label="{{ 'ENABLE_PASSWORD' | translate }}" (click)="editPassword()" icon="pi cm-key"
                                [rounded]="false" [text]="true" severity="danger" styleClass="font-bold border-red-600">
                            </p-button>
                            <p-button *ngIf="isMTMAConnect()" [rounded]="false" [text]="true"
                                label="{{ 'CLONE_MTMAC' | translate }}" (click)="cloneMtma()" icon="pi cm-key"
                                severity="danger" styleClass="font-bold border-red-600">
                            </p-button>
                        </div>
                    </div>
                </p-accordion>
            </p-tabPanel>
            <!-- AUTOMATION && RBE -->
            <p-tabPanel *ngIf="hasBoardUsers()" header="{{ 'USERS_DEVICE' | translate }}"
                leftIcon="{{needResync? 'pi cm-alert':''}}" tooltipPosition="bottom"
                tooltip="{{ needResync? ('BOARD_USERS_SYNC_USERS_DEVICES' | translate):'' }}">
                <app-board-users></app-board-users>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasManageControlAccess()" header="{{ 'MANAGE_CONTROL_ACCESS' | translate }}">
                <app-control-access-tab></app-control-access-tab>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasAccessLog()" header="{{ 'ACCESS_LOG' | translate }}">
                <app-rbe-log-access></app-rbe-log-access>
            </p-tabPanel>
            <p-tabPanel *ngIf="hasTimers() && device.CurrentlyOwned && clockPresent"
                header="{{ 'TIMERS' | translate }}">
                <p-accordion>
                    <app-timers-list-timers></app-timers-list-timers>
                    <app-timers-list-special-day></app-timers-list-special-day>
                </p-accordion>
            </p-tabPanel>
            <!-- TH -->
            <p-tabPanel *ngIf="isThermoDevice() && device.CurrentlyOwned && !isImpersMode"
                header="{{ 'THERMO_LOG' | translate }}">
                <app-thermo-stats></app-thermo-stats>
            </p-tabPanel>
            <!-- AUTOMATION IMPORT / EXPORT !! DONT SORT IN THIS FILE -->
            <!--<p-tabPanel *ngIf="hasManageImportExport()" header="{{ 'MANAGE_IMPORT_EXPORT' | translate }}">
                <app-import-export-tab></app-import-export-tab>
            </p-tabPanel>-->
            <!-- MTMA IMPORT / EXPORT !! DONT SORT IN THIS FILE -->
            <p-tabPanel *ngIf="hasManageImportExportMtma()" header="{{ 'MANAGE_IMPORT_EXPORT' | translate }}">
                <app-mtma-import-export-tab></app-mtma-import-export-tab>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
<p-confirmDialog #confDialog class="p-confirm-dialog-content">
    <ng-template pTemplate="footer">
        <div class="col-12 flex justify-content-center">
            <button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
                (click)="confDialog.reject()">
            </button>
        </div>
    </ng-template>
</p-confirmDialog>